module.exports = __webpack_public_path__ + "img/android.a0f8fccb.png";